import React from "react";
import PageLayout from "../components/PageLayout";

export default function Empresas() {
  const cards = [
    {
      title: "Formação in company",
      text: "Programas realizados nas instalações do cliente ou no CENFOTEP, com casos ligados ao trabalho da equipa.",
      points: ["Diagnóstico", "Calendário flexível", "Avaliação"],
    },
    {
      title: "Plano de serviços",
      text: "Apoio recorrente em tecnologia, gráfica e repografia com condições definidas para a organização.",
      points: ["Ponto de contacto", "Prazos acordados", "Controlo de pedidos"],
    },
    {
      title: "Eventos e campanhas",
      text: "Suporte à preparação de materiais, equipas e recursos para acções internas ou externas.",
      points: ["Planeamento", "Produção", "Entrega"],
    },
  ];
  return (
    <PageLayout
      eyebrow="CENFOTEP Empresas"
      title="Equipas mais capazes. Operações mais eficientes."
      intro="Ajudamos empresas e instituições a desenvolver pessoas e executar serviços com menos dispersão, mais controlo e um parceiro responsável."
      sectionTitle="Soluções empresariais adaptadas"
      sectionIntro="Não aplicamos pacotes rígidos. Analisamos dimensão da equipa, necessidades, calendário e orçamento para propor uma solução realista."
      cards={cards}
      steps={[
        { title: "Reunião", text: "Compreendemos prioridades e público." },
        {
          title: "Diagnóstico",
          text: "Identificamos lacunas e oportunidades.",
        },
        {
          title: "Proposta",
          text: "Definimos escopo, calendário e investimento.",
        },
        { title: "Execução", text: "Entregamos e avaliamos os resultados." },
      ]}
    />
  );
}
